import { formatDate } from "@shared/utils/dates/formatting";
import { useCallback, useMemo } from "react";
import useRedirect from "@shared/hooks/useRedirect.web";
import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { isSoldOutEvent } from "@shared/modules/events/utils/event-utils";
import { MapTimeslotItemProps } from "./MapTimeslotItem.props";

const MapTimeslotItem = ({
  childEvent,
  titleFontSize,
  dateFontSize,
  containerPadding,
  closeModal,
}: MapTimeslotItemProps) => {
  const { t } = useTranslation("seating");
  const { redirect } = useRedirect();

  const isSoldOut = useMemo(() => isSoldOutEvent(childEvent), [childEvent]);

  const onClickTimeslot = useCallback(() => {
    if (isSoldOut) {
      return;
    }
    redirect(`/${childEvent.slug}/seating/`);

    // if the timeslot modal is open, close it
    if (closeModal) {
      closeModal();
    }
  }, [isSoldOut, childEvent.slug, closeModal, redirect]);

  return (
    <Box
      onClick={onClickTimeslot}
      cursor={isSoldOut ? "default" : "pointer"}
      borderBottom="1px solid var(--chakra-colors-gray-400)"
      p={containerPadding}
    >
      {isSoldOut ? (
        <Text
          color="red.600"
          fontSize={dateFontSize || "14px"}
          fontWeight="bold"
        >
          {t("Sold Out", { ns: "common" })}
        </Text>
      ) : null}
      <Box opacity={isSoldOut ? "0.3" : "1"}>
        <Text
          fontWeight="bold"
          color="primary.500"
          overflow="hidden"
          whiteSpace="normal"
          noOfLines={3}
          fontSize={titleFontSize || "16px"}
        >
          {childEvent.name}
        </Text>
        <Text fontSize={dateFontSize || "16px"}>
          {formatDate({
            date: childEvent.starts_on,
            timezone: childEvent.timezone,
            format: "ddd MMM D | h:mm A z",
          })}
        </Text>
      </Box>
    </Box>
  );
};

export default MapTimeslotItem;
